import React from 'react'
import '@minko-fe/use-antd-resizable-header/dist/index.css'
import { Table } from 'antd'
import styled from 'styled-components'
import BatchPanel from './batch-panel'

interface PropsType extends React.ComponentProps<typeof Table> {
  columns: any[]
  dataSource: any[]
  loading: boolean
  pageSize: number
  page: number
  total: number
  onChange: (pagination: any, filters: any, sorter: any) => void
  selectedRowKeys: string[]
  rowSelection: any
  batchOperation: any
}

const TablePanel: React.FC<PropsType> = ({
  dataSource,
  columns,
  loading,
  pageSize,
  page,
  total,
  onChange,
  selectedRowKeys,
  rowSelection,
  batchOperation,
  scroll,
}) => (
  <div style={{ paddingRight: '14px' }}>
    {selectedRowKeys && selectedRowKeys.length > 0 && (
      <BatchPanel batchOperation={batchOperation} />
    )}
    <TableWrapper
      key={`table-${total}-${dataSource?.length || 0}`}
      columns={columns}
      dataSource={dataSource?.filter(item => item)}
      rowSelection={rowSelection}
      loading={loading}
      scroll={scroll}
      onChange={onChange}
      rowKey="id"
      showSorterTooltip={false}
      pagination={{
        position: 'bottomRight',
        pageSize,
        current: page,
        total,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
        showTotal: () => `${t('共')} ${total} ${t('条')}`,
      }}
    />
  </div>
)

export default TablePanel

const TableWrapper = styled(Table)`
  .ant-table-measure-row {
    td {
      padding: 0 !important;
    }
  }

  .ant-space {
    gap: 0 !important;

    &.space-btn .ant-space-item {
      margin-right: 8px !important;
    }
  }

  .ant-table-column-sorter {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ant-table-column-sorters {
    justify-content: flex-start;

    .ant-table-column-title {
      flex: none;
    }
  }

  .ant-table-filter-column {
    justify-content: flex-start;

    .ant-table-column-title {
      flex: unset;
    }

    .ant-table-filter-trigger:hover {
      background: transparent;
    }
  }

  .ant-table-measure-row {
    display: none;
  }

  --arh-color: #4238c9;

  .leak-low {
    display: inline-block;
    width: 36px;
    height: 16px;
    background: #6f9fff;
    border-radius: 4px;
    margin-left: 10px;
    font-size: 12px;
    color: #fff;
    line-height: 16px;
    text-align: center;
  }

  .leak-center {
    display: inline-block;
    width: 36px;
    height: 16px;
    background: #ffa709;
    border-radius: 4px;
    margin-left: 10px;
    font-size: 12px;
    color: #fff;
    line-height: 16px;
    text-align: center;
  }

  .leak-high {
    display: inline-block;
    width: 36px;
    height: 16px;
    background: #ff4141;
    border-radius: 4px;
    margin-left: 10px;
    font-size: 12px;
    color: #fff;
    line-height: 16px;
    text-align: center;
  }

  .leak-severity {
    display: inline-block;
    width: 36px;
    height: 16px;
    background: #b70000;
    border-radius: 4px;
    margin-left: 10px;
    font-size: 12px;
    color: #fff;
    line-height: 16px;
    text-align: center;
  }

  .device-test {
    color: #72b851;
  }

  .device-success {
    color: #5677d9;
  }

  .device-fail {
    color: #ee6666;
  }

  .device-cancel {
    color: #677280;
  }

  .intercept-success {
    display: inline-block;
    width: 60px;
    height: 18px;
    background: #e5eeff;
    border-radius: 4px 12px 4px 12px;
    color: #2973ff;
    text-align: center;
    line-height: 18px;
    font-size: 12px;
  }

  .intercept-fail {
    display: inline-block;
    width: 60px;
    height: 18px;
    background: #fde5e5;
    border-radius: 4px 12px 4px 12px;
    color: #f44f4f;
    text-align: center;
    line-height: 18px;
    font-size: 12px;
  }

  .test-success {
    display: inline-block;
    width: 60px;
    height: 18px;
    background: #e9f5e3;
    border-radius: 4px 12px 4px 12px;
    color: #72b851;
    text-align: center;
    line-height: 18px;
    font-size: 12px;
  }

  .detection-success {
    display: inline-block;
    width: 60px;
    height: 18px;
    background: #e9f5e3;
    border-radius: 4px 12px 4px 12px;
    color: #72b851;
    text-align: center;
    line-height: 18px;
    font-size: 12px;
  }

  .intercept-cancel {
    display: inline-block;
    width: 60px;
    height: 18px;
    background: #d9d9d9;
    border-radius: 4px 12px 4px 12px;
    color: #666;
    text-align: center;
    line-height: 18px;
    font-size: 12px;
  }

  .log-alarm-fail {
    display: inline-block;
    width: 44px;
    height: 16px;
    background: #3586ff;
    border-radius: 4px;
    font-size: 12px;
    color: #fff;
    line-height: 16px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .log-alarm-success {
    display: inline-block;
    width: 44px;
    height: 16px;
    background: #f44f4f;
    border-radius: 4px;
    font-size: 12px;
    color: #fff;
    line-height: 16px;
    text-align: center;
  }

  .dynamic-encoding {
    display: inline-block;
    width: 60px;
    height: 18px;
    background: #ffeddf;
    border-radius: 6px;
    font-size: 12px;
    color: #fba159;
    line-height: 18px;
    text-align: center;
  }

  .static-encoding {
    display: inline-block;
    width: 60px;
    height: 18px;
    background: #fce4df;
    border-radius: 6px;
    font-size: 12px;
    color: #f37c60;
    line-height: 18px;
    text-align: center;
  }

  .operation {
    color: #4238c9;

    span {
      margin-left: 6px;

      &:hover {
        cursor: pointer;
      }
    }
  }
  .ant-table-pagination.ant-pagination {
    margin-top: 24px;
  }
`
